export enum meetingModalEnum {
  LINK = "LINK",
  JOIN = "JOIN",
  INSTANT = "INSTANT",
  LATER = "LATER"
}
